import { QueryClient } from '@tanstack/react-query'

// Centralny cache dla danych z API (TanStack Query).
// Poniższe ustawienia są DOMYŚLNE dla wszystkich zapytań - pojedyncze useQuery
// może je nadpisać (np. dłuższy staleTime dla danych, które rzadko się zmieniają).
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Jak długo dane są uznawane za świeże. Przez ten czas ponowne wejście
            // na stronę bierze dane z cache i NIE odpytuje API.
            // Po upływie tego czasu dane nadal są pokazywane od razu z cache,
            // ale w tle leci ciche odświeżenie (stale-while-revalidate).
            staleTime: 30 * 1000,

            // Jak długo nieużywane dane zostają w pamięci, zanim zostaną wyrzucone.
            // Dzięki temu powrót na stronę po kilku minutach nadal pokazuje dane od razu.
            gcTime: 10 * 60 * 1000,

            // Odświeżanie po powrocie do karty przeglądarki - wyłączone, żeby ruch
            // do API był przewidywalny. Włączamy świadomie tam, gdzie ma to sens.
            refetchOnWindowFocus: false,

            // Nie ponawiamy zapytań odrzuconych przez serwer (400/401/403/404) -
            // ponowienie i tak skończy się tym samym błędem. Błędy sieciowe ponawiamy raz.
            retry: (failureCount, error) => {
                const status = error?.response?.status
                if (status >= 400 && status < 500) {
                    return false
                }
                return failureCount < 1
            },
        },
    },
})

export default queryClient
